(() => {
  const publish = (name, data = {}) => {
    if (document.body.dataset.shlepTracking !== 'true') return;
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, data);
    }
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const select = form.querySelector('[name="id"]');
      if (!select || select.tagName !== 'SELECT') return;
      const update = () => {
        const option = select.options[select.selectedIndex];
        const button = form.querySelector('[type="submit"]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.available;
        const price = form.closest('[data-shlep-product]').querySelector('[data-product-price]');
        if (price) price.textContent = option.dataset.price;
      };
      select.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('[data-waitlist-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) return;
        const consent = form.querySelector('[data-waitlist-consent]');
        if (!consent || !consent.checked) event.preventDefault();
      });
    });
    root.querySelectorAll('[data-waitlist-success]').forEach(element => {
      if (element.dataset.tracked) return;
      element.dataset.tracked = 'true';
      publish('shlep_waitlist_signup_completed', {purpose:'next-run-updates',consent_version:'2026-09-27'});
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const element = entry.target;
          if (!element.dataset.interestTracked) {
            element.dataset.interestTracked = 'true';
            publish('shlep_product_interest', {product_id:element.dataset.productId || null,source:document.body.dataset.pageType});
          }
          observer.unobserve(element);
        });
      }, {threshold:0.25});
      root.querySelectorAll('[data-shlep-product]').forEach(element => observer.observe(element));
    }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-shlep-cta]');
    if (target) publish('shlep_cta_clicked', {location:target.dataset.shlepCta});
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
})();
